'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.route.service
 * @description
 * # route.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp').service('routeService', function () {
  var routeService = {
    getPathFromRoute: getPathFromRoute
  };

  function getPathFromRoute(next) {
    var route = next.$$route;
    var path = route.originalPath;
    if (!!next && !!next.params && !angular.equals(!!next.params, {})) {
      return Object.values(next.params)
        .filter(function (key) {
          return next.params.hasOwnProperty(key);
        })
        .reduce(function (previous, key) {
          return previous.replace(':' + key, next.params[key]);
        }, path);
    }

    throw new Error('next.params was empty or undefined ');
  }

  return routeService;
});
